import React from 'react';
import TextField from 'material-ui/TextField';
import Dialog from '../overlay/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import OverlayController from '../overlay/OverlayController';
import mutations from '../../graphql/mutations';
import { compose } from 'react-apollo';
import { errorOrGraphQLMessage } from '../../utils/utils';
import './AddUserDialog.css';

class AddUserDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            userEmail: '',
            errorMessage: '',
            role: null
        };
    }

    didChangeUserEmail(event) {
        this.setState({
            userEmail: event.target.value,
            errorMessage: ''
        });
    }

    didChangeRole(event, index, value) {
        this.setState({
            role: value
        });
    }

    didClickAddUserButton() {
        this.props.createACL(this.state.userEmail, this.props.project.id, 'Project', this.state.role)
            .then(({data}) => {
                console.log('got data', data);
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                console.log('there was an error sending the query', {error});
                this.setState({errorMessage: errorOrGraphQLMessage(error)});
            });
    }

    isSubmitEnabled() {
        return this.state.userEmail.trim() !== '' && this.state.role !== null;
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Add User', handler: this.didClickAddUserButton.bind(this), disabled: !this.isSubmitEnabled()}
        ];
        return (
            <Dialog title={`User Roles`} actions={actions} className="add-user-dialog">
                <TextField
                    className="custom-field"
                    fullWidth={true}
                    floatingLabelText="User Email"
                    floatingLabelFixed={true}
                    hintText="Enter User Email"
                    errorText={this.state.errorMessage}
                    value={this.state.userEmail}
                    onChange={this.didChangeUserEmail.bind(this)}
                />
                <SelectField
                    className="custom-field custom-select-field"
                    fullWidth={true}
                    floatingLabelText="User Role"
                    floatingLabelFixed={true}
                    hintText="Select User Role"
                    value={this.state.role}
                    onChange={this.didChangeRole.bind(this)}>
                    <MenuItem value='admin' primaryText="Admin" />
                    <MenuItem value='viewer' primaryText="Viewer" />
                </SelectField>
            </Dialog>
        );
    }
}

export default compose(
    mutations.createACLMutationHoc
)(AddUserDialog);



// WEBPACK FOOTER //
// ./src/components/projectSettings/AddUserDialog.js